export class ConfirmResult {
    Action: string = "";
    InstructionType: number = -1;
    Id: number = -1;
}


// WEBPACK FOOTER //
// C:/Users/SHR6M3/Development/PackITWebGui/src/app/dialogboxes/shared/confirm.model.ts